import { api } from "../../App";
import { getObjectFromArray } from "../../utils/smallHelpers";
import { SET_SETTINGS_ABOUT_DATA, SET_SETTINGS_LOADING } from "../types";
import { API_BASE_URL } from "../../assets/const";
import { checkAndUpdateToken } from "../auth";
import { createNotification } from "../../components/Notifications/Notifications";



export const getAboutData = () => async (dispatch, getState) => {
    try {
      dispatch({ type: SET_SETTINGS_LOADING, payload: true });
      const { data } = await api.get('/education_organisation_option')
      const payload = getObjectFromArray(data.options)
      dispatch({ type: SET_SETTINGS_ABOUT_DATA, payload })

    } catch (ERR) {
      console.log(ERR)
    } finally {
      dispatch({ type: SET_SETTINGS_LOADING, payload: false });
    }
};

export const uploadAboutFile = (file, fieldName) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  const fd = new FormData();
  fd.append("file", file);

  if (getState().auth.token) {
    try {
      const response = await fetch(`${API_BASE_URL}/education_organisation_option/file/${fieldName}`, {
        method: "POST",
        body: fd,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Basic ${btoa(`nnz:${getState().auth.token}`)}`,
        },
      });
      if (response.ok) {
        createNotification('success', 'Файл успешно загружен');
      } else {
        createNotification('error', 'Ошибка загрузки файла');
      }
    } catch (err) {
      console.log(err);
      createNotification('error', 'Ошибка загрузки файла');
    }
  }
};

export const deleteAboutFile = (fieldName, fileName) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    try {
      const response = await fetch(`${API_BASE_URL}/education_organisation_option/file/${fieldName}/${fileName}`, {
        method: "DELETE",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Basic ${btoa(`nnz:${getState().auth.token}`)}`,
        },
      });
      if (response.ok) {
        createNotification('success', 'Файл успешно удален');
      } else {
        createNotification('error', 'Ошибка удаления файла');
      }
    } catch (err) {
      console.log(err);
      createNotification('error', 'Ошибка удаления файла');
    }
  }
};

export const downloadAboutFile = (fieldName, fileName) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    try {
      const response = await fetch(`${API_BASE_URL}/education_organisation_option/file/${fieldName}/${fileName}`, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Basic ${btoa(`nnz:${getState().auth.token}`)}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      } else {
        createNotification('error', 'Ошибка скачивания файла');
      }
    } catch (err) {
      console.log(err);
      createNotification('error', 'Ошибка скачивания файла');
    }
  }
};